import { Column } from '../modules/store/partList/partListReducer'

export const defaultCustomizableColumns: Column[] = [
    { id: 'groupId', label: 'Иконка категории' },
    { id: 'customTitle', label: 'Название запчасти' },
    { id: 'markTitle', label: 'Марка авто' },
    { id: 'modelTitle', label: 'Модель авто' },
    { id: 'photo', label: 'Фото' },
    { id: 'price', label: 'Цена' },
    { id: 'vendorCode', label: 'Артикул' },
    { id: 'partNumber', label: 'OEM' },
    { id: 'createdAt', label: 'Дата создания' },
    { id: 'updatedAt', label: 'Дата ред' },
    { id: 'quantity', label: 'Количество' },
    { id: 'actions', label: 'Действия' },
]

export const allCustomizableColumns: Column[] = [
    ...defaultCustomizableColumns,
    { id: 'accepted', label: 'Принято' },
    { id: 'position', label: 'Расположение' },
    { id: 'warehouseTitle', label: 'Склад' },
    { id: 'warehousePlace', label: 'Место на складе' },
    { id: 'warehouseSection', label: 'Секция' },
    { id: 'sticker', label: 'QR' },
    { id: 'partId', label: 'Avito ID' },
    { id: 'incomingInvoiceTitle', label: 'Номер приходной накладной' },
    { id: 'pricePurchase', label: 'Цена закупки' },
    { id: 'year', label: 'Год' },
    { id: 'conditionId', label: 'Состояние' },
    { id: 'typeId', label: 'Тип запчасти' },
    { id: 'ozon', label: 'Ozon' },
    { id: 'dimensions', label: 'Габариты' },
]

export const defaultCustomizableColumnsSold: Column[] = [
    { id: 'groupId', label: 'Иконка категории' },
    { id: 'customTitle', label: 'Название запчасти' },
    { id: 'markTitle', label: 'Марка авто' },
    { id: 'modelTitle', label: 'Модель авто' },
    { id: 'photo', label: 'Фото' },
    { id: 'vendorCode', label: 'Артикул' },
    { id: 'partNumber', label: 'OEM' },
    { id: 'soldQuantity', label: 'Количество' },
    { id: 'soldPrice', label: 'Цена продажи' },
    { id: 'soldAt', label: 'Дата продажи' },
    { id: 'actions', label: 'Действия' },
]

export const allCustomizableColumnsSold: Column[] = [
    ...defaultCustomizableColumnsSold,
    { id: 'createdAt', label: 'Дата создания' },
    { id: 'warehouseTitle', label: 'Склад' },
    { id: 'pricePurchase', label: 'Цена закупки' },
    { id: 'typeId', label: 'Тип запчасти' },
]

export const defaultCustomizableColumnsCar: Column[] = [
    { id: 'donorId', label: 'Номер' },
    { id: 'photo', label: 'Фото' },
    { id: 'markTitle', label: 'Марка' },
    { id: 'modelTitle', label: 'Модель' },
    { id: 'year', label: 'Год' },
    { id: 'modificationTitle', label: 'Модификация' },
    { id: 'bodyTypeTitle', label: 'Кузов' },
    { id: 'mileage', label: 'Пробег' },
    { id: 'price', label: 'Закуп' },
    { id: 'sumSoldParts', label: 'Продажи' },
    { id: 'createdAt', label: 'Дата создания' },
    { id: 'partsCnt', label: 'Запчасти' },
    { id: 'actions', label: 'Действия' },
]

export const allCustomizableColumnsCar: Column[] = [
    ...defaultCustomizableColumnsCar,
    { id: 'description', label: 'Описание (внутренне)' },
    { id: 'steeringType', label: 'Руль' },
    { id: 'equipment', label: 'Комплектация' },
    { id: 'bodycars', label: 'Модель кузова' },
    { id: 'engine', label: 'Модель двигателя' },
]

export const getOrderColumns = ({
    order,
    defaultColumns = allCustomizableColumns,
}: {
    order?: string[]
    defaultColumns?: Column[]
}): Column[] => {
    if (!order) return defaultColumns

    return order.flatMap(id => {
        const col = defaultColumns.find(c => c.id === id)
        return col ? [col] : []
    })
}
